import { render, staticRenderFns } from "./pending_payment.vue?vue&type=template&id=b3c3a816&scoped=true&"
import script from "./pending_payment.vue?vue&type=script&lang=js&"
export * from "./pending_payment.vue?vue&type=script&lang=js&"
import style0 from "./pending_payment.vue?vue&type=style&index=0&id=b3c3a816&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c3a816",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
